export const admin = "ADMIN";

export const rootProtectedPath = "explore";

export const scopeActions = {
	READ: { name: "READ", key: "read" },
	CREATE: { name: "CREATE", key: "create" },
	UPDATE: { name: "UPDATE", key: "update" },
	PUBLISH: { name: "PUBLISH", key: "publish" },
};

export const departments = {
	DESIGNER: { name: "DESIGNER", key: "DESIGNER" },
	BUYING_PLANNING: { name: "BUYING & PLANNING", key: "BUYING_PLANNING" },
	HR_ADMIN: { name: "HR & ADMIN", key: "HR_ADMIN" },
	SOURCING: { name: "SOURCING", key: "SOURCING" },
	MDM: { name: "MDM", key: "MDM" },
	STUDIO: { name: "STUDIO", key: "STUDIO" },
	CATALOGUE: { name: "CATALOGUE", key: "CATALOGUE" },
};

export const services = {
	CREATE_STYLE: { name: "CREATE STYLE", key: "CREATE_STYLE", department: departments.DESIGNER },
	BULK_UPLOAD_STYLES: { name: "BULK UPLOAD STYLES", key: "BULK_UPLOAD_STYLES", department: departments.DESIGNER },
	FABRIC_TRIMS: { name: "FABRIC TRIMS", key: "FABRIC_TRIMS", department: departments.DESIGNER },
	BUYING: { name: "BUYING ", key: "BUYING", department: departments.BUYING_PLANNING },
	STORE_PROJECTION: { name: "STORE PROJECTION ", key: "STORE_PROJECTION", department: departments.BUYING_PLANNING },
	STYLES_DASHBOARD: { name: "STYLES DASHBOARD", key: "STYLES_DASHBOARD", department: departments.DESIGNER },
	ATTRIBUTES: { name: "ATTRIBUTES", key: "ATTRIBUTES", department: departments.MDM },
	ATTRIBUTE_GROUPS: { name: "ATTRIBUTE GROUPS", key: "ATTRIBUTE_GROUPS", department: departments.MDM },
	PRODUCTION_ALLOCATION: { name: "PRODUCTION ALLOCATION", key: "PRODUCTION_ALLOCATION", department: departments.SOURCING },
	USERS: { name: "USERS", key: "USERS", department: departments.HR_ADMIN },
	MERCHANT_SAMPLE_DATA: { name: "MERCHANT SAMPLE DATA", key: "MERCHANT_SAMPLE_DATA", department: departments.SOURCING },
	CREATE_SHOOT: { name: "CREATE SHOOT", key: "CREATE_SHOOT", department: departments.STUDIO },
	ALL_SHOOTS: { name: "ALL SHOOTS", key: "ALL_SHOOTS", department: departments.STUDIO },
	SHOOT_ARCHIVE: { name: "SHOOT ARCHIVE", key: "SHOOT_ARCHIVE", department: departments.STUDIO },
	CREATE_SHOOT_COSTING: { name: "CREATE SHOOT COSTING", key: "CREATE_SHOOT_COSTING", department: departments.STUDIO },
	ALL_SHOOT_COSTINGS: { name: "ALL SHOOT COSTINGS", key: "ALL_SHOOT_COSTINGS", department: departments.STUDIO },
	SHOOT_ATTRIBUTES: { name: "SHOOT ATTRIBUTES", key: "SHOOT_ATTRIBUTES", department: departments.STUDIO },
	MODAL_PROFILE_ATTRIBUTES: { name: "MODAL PROFILE ATTRIBUTES", key: "MODAL_PROFILE_ATTRIBUTES", department: departments.STUDIO },
	CREATE_MODAL_PROFILE: { name: "CREATE MODAL PROFILE", key: "CREATE_MODAL_PROFILE", department: departments.STUDIO },
	ALL_MODAL_PROFILES: { name: "ALL MODAL PROFILES", key: "ALL_MODAL_PROFILES", department: departments.STUDIO },
	STUDIO_SAMPLE_INWARD: { name: "STUDIO SAMPLE INWARD", key: "STUDIO_SAMPLE_INWARD", department: departments.STUDIO },
	CREATE_OPEN_COSTING: { name: "CREATE OPEN COSTING", key: "CREATE_OPEN_COSTING", department: departments.SOURCING },
	OPEN_COSTING_DASHBOARD: { name: "OPEN COSTING DASHBOARD", key: "OPEN_COSTING_DASHBOARD", department: departments.SOURCING },
	ALL_OPEN_COSTINGS: { name: "ALL OPEN COSTINGS", key: "ALL_OPEN_COSTINGS", department: departments.SOURCING },
	STYLE_FARBRIC_MASTER: { name: "STYLE FARBRIC MASTER", key: "STYLE_FARBRIC_MASTER", department: departments.SOURCING },
	STYLE_TRIMS_MASTER: { name: "STYLE TRIMS MASTER", key: "STYLE_TRIMS_MASTER", department: departments.SOURCING },
	STYLE_FARBRIC_DETAILS: { name: "STYLE DETAILS", key: "STYLE_FARBRIC_DETAILS", department: departments.SOURCING },
	STYLE_BlOCK_MASTER: { name: "STYLE BLOCK MASTER", key: "STYLE_BlOCK_MASTER", department: departments.CATALOGUE },
	STYLE_TRIM_MASTER: { name: "STYLE TRIM MASTER", key: "STYLE_TRIM_MASTER", department: departments.SOURCING },
	CREATE_STYLE_TRIM: { name: "CREATE STYLE TRIM", key: "CREATE_STYLE_TRIM_", department: departments.SOURCING },
};

export const scopes = {
	FABRIC_CATEGORY: {
		name: "Fabric Category",
		key: "fabric_category",
		resource: services.STYLE_FARBRIC_MASTER.key,
		actions: [scopeActions.READ.key, scopeActions.CREATE.key, scopeActions.UPDATE.key],
		options: [
			{ name: "KNIT", key: "KNIT" },
			{ name: "WOVEN", key: "WOVEN" },
		],
	},
	STYLE_CATEGORY: {
		name: "Style Category",
		key: "style_category",
		resource: services.CREATE_STYLE.key,
		actions: [scopeActions.READ.key, scopeActions.CREATE.key, scopeActions.UPDATE.key],
		options: [],
	},
	// TRIMS_CATEGORY: {
	// 	name: "Trims Category",
	// 	key: "trims_category",
	// 	resource: services.STYLE_TRIMS_MASTER.key,
	// 	actions: [scopeActions.READ.key, scopeActions.CREATE.key, scopeActions.UPDATE.key],
	// 	options: [
	// 		{ name: "LABEL", key: "LABEL" },
	// 		{ name: "BUTTON", key: "BUTTON" },
	// 		{ name: "BADGE", key: "BADGE" },
	// 		{ name: "ELASTIC", key: "ELASTIC" },
	// 		{ name: "HANGTAG", key: "HANGTAG" },
	// 		{ name: "METAL", key: "METAL" },
	// 		{ name: "TAPE", key: "TAPE" },
	// 		{ name: "STICKER", key: "STICKER" },
	// 		{ name: "STRING", key: "STRING" },
	// 		{ name: "CORD", key: "CORD" },
	// 		{ name: "OTHERS", key: "OTHERS" },
	// 		{ name: "LACE", key: "LACE" },
	// 	],
	// },
	TRIMS_BRAND: {
		name: "Trims Brand",
		key: "brand",
		resource: services.STYLE_TRIMS_MASTER.key,
		actions: [scopeActions.READ.key, scopeActions.CREATE.key, scopeActions.UPDATE.key],
		options: [
			{ name: "RARE RABBIT", key: "RARE RABBIT" },
			{ name: "RAREISM", key: "RAREISM" },
			{ name: "RARE ONES", key: "RARE ONES" },
			{ name: "RAREZ", key: "RAREZ" },
		],
	},
};
export const custom = {
	STYLE_VIEWER: { name: "STYLE VIEWER", key: "STYLE_VIEWER" },
	STYLE_REVIEWER: { name: "STYLE REVIEWER", key: "STYLE_REVIEWER" },
	STYLE_FARBRIC_MASTER_VIEWER: { name: "STYLE FABRIC MASTER VIEWER", key: "STYLE_FARBRIC_MASTER_VIEWER" },
	STYLE_TRIMS_MASTER_VIEWER: { name: "STYLE TRIMS MASTER VIEWER", key: "STYLE_TRIMS_MASTER_VIEWER" },
	STYLE_BLOCK_MASTER_VIEWER: { name: "STYLE BLOCK MASTER VIEWER", key: "STYLE_BLOCK_MASTER_VIEWER" },
	SAMPLE_INWARD_VIEWER: { name: "SAMPLE INWARD VIEWER", key: "SAMPLE_INWARD_VIEWER" },
	COSTING_VIEWER: { name: "COSTING VIEWER", key: "COSTING_VIEWER" },
	PRODUCTION_ALLOC_PUBLISHER: { name: "PRODUCTION ALLOC PUBLISHER", key: "PRODUCTION_ALLOC_PUBLISHER" },
	COSTING_PUBLISHER: { name: "COSTING PUBLISHER", key: "COSTING_PUBLISHER" },
	SHOOT_VIEWER: { name: "SHOOT VIEWER", key: "SHOOT_VIEWER" },
	SHOOT_COSTING_VIEWER: { name: "SHOOT COSTING VIEWER", key: "SHOOT_COSTING_VIEWER" },
	MODAL_PROFILE_VIEWER: { name: "MODAL PROFILE VIEWER", key: "MODAL_PROFILE_VIEWER" },
	STYLE_PUBLISHER: { name: "STYLE PUBLISHER", key: "STYLE_PUBLISHER" },
	SHOOT_PUBLISHER: { name: "SHOOT PUBLISHER", key: "SHOOT_PUBLISHER" },
	SHOOT_COSTING_PUBLISHER: { name: "SHOOT COSTING PUBLISHER", key: "SHOOT_COSTING_PUBLISHER" },
	MODAL_PROFILE_PUBLISHER: { name: "MODAL PROFILE PUBLISHER", key: "MODAL_PROFILE_PUBLISHER" },
	TRIM_PUBLISHER: { name: "TRIM PUBLISHER", key: "TRIM_PUBLISHER" },
	BLOCK_TRIM_SUPPLIER_PRICING: {
		name: "TRIMS MASTER VIEW (NO SUPPLIER)",
		key: "BLOCK_TRIM_SUPPLIER_PRICING",
	},
};
export const externalTypes = {
	SUPPLIER: { name: "Supplier", key: "SUPPLIER" },
};

export const userTypes = {
	internal: "INTERNAL",
	external: "EXTERNAL",
};
